import React, { useState } from 'react';
import './project.css';

const projects = [
  {
    title: 'Berryfy',
    status: 'Building',
    statusClass: 'bg-danger',
    icon: 'bx bx-store project__icon',
    summary: 'Open-source, self-hosted e-commerce engine for anyone who wants to own a digital store without fees or gatekeepers.',
    date: 'May 2025 - Present',
    links: [
      { label: 'Website', href: 'https://berryfy.org' }
    ],
    highlights: [
      'Self-hosted digital store platform focused on ownership, extensibility, and practical merchant workflows.',
      'Built with TypeScript, backend web development, REST APIs, and a modern web application architecture.'
    ],
    skills: 'Back-End Web Development, TypeScript, REST APIs, Web Applications'
  },
  {
    title: 'AI Voice Agent Systems',
    status: 'Callby.ai',
    statusClass: 'bg-success',
    icon: 'bx bx-bot project__icon',
    summary: 'Dual-agent voice systems and automated service agents for support, verification, policy inquiry, and ticketing flows.',
    date: '2025 - Present',
    links: [],
    highlights: [
      'Designed prompt-engineered voice agents that handle call-merging scenarios, trip verification, and payment disputes.',
      'Deployed automated customer service and ticketing agents for insurance, pharmaceutical, and platform workflows.'
    ],
    skills: 'Prompt Engineering, RAG, FastAPI, PostgreSQL, n8n'
  },
  {
    title: 'Knowledge Base Automation',
    status: 'RAG',
    statusClass: 'bg-success',
    icon: 'bx bx-data project__icon',
    summary: 'Smart assistant and knowledge-base routing systems using PostgreSQL, pgvector, SMS integrations, and structured data retrieval.',
    date: '2025',
    links: [],
    highlights: [
      'Architected automated routing and SMS integration flows for a local municipality-style service system.',
      'Connected transcripts, SQL databases, and structured JSON payloads into reliable operational workflows.'
    ],
    skills: 'PostgreSQL, pgvector, SQL, JSON, Workflow Automation'
  },
  {
    title: 'Portfolio Website',
    status: 'Version 1.0',
    statusClass: 'bg-success',
    icon: 'bx bx-briefcase project__icon',
    summary: 'Personal portfolio website built to showcase professional projects, technical skills, and accomplishments.',
    date: '2024 - Present',
    links: [
      { label: 'Website', href: 'https://hamidshahade.com' }
    ],
    highlights: [
      'Responsive React interface optimized for mobile and desktop visitors.',
      'Clean project, skill, service, and contact sections for fast professional review.'
    ],
    skills: 'React.js, JavaScript, HTML, CSS'
  },
  {
    title: 'Movieland24.com',
    status: 'Version 1.0',
    statusClass: 'bg-success',
    icon: 'bx bx-movie-play project__icon',
    summary: 'Movie information and cinema-ticket web system with admin management, order history, and user accounts.',
    date: '2023 - 2024',
    links: [
      { label: 'Website', href: 'https://movieland24.com' }
    ],
    highlights: [
      'Built movie, actor, producer, and category management features.',
      'Added ticket shopping cart, order history, login, registration, and admin CRUD workflows.'
    ],
    skills: 'ASP.NET, SQL Server, Entity Framework, Razor Pages'
  }
];

const Project = () => {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <section className="project section" id="project">
      <div>
        <h2 className="section__title">Projects</h2>
        <span className="section__subtitle">Selected work and products</span>

        <div className="project__container container grid">
          {projects.map((project, index) => (
            <div className="project__content" key={project.title}>
              <div className="project__status">
                <span className={`badge ${project.statusClass} text-white`}>{project.status}</span>
              </div>
              <div>
                <i className={project.icon}></i>
                <h3 className="project__title">{project.title}</h3>
                <p className="project__summary">{project.summary}</p>
                <span className="project__button" onClick={() => setActiveProject(index)}>
                  View More
                  <i className="uil uil-arrow-right project__button-icon"></i>
                </span>
              </div>

              <div className={activeProject === index ? 'projects__modal active-modal' : 'projects__modal'}>
                <div className="projects__modal-content">
                  <i className="uil uil-times projects__modal-close" onClick={() => setActiveProject(null)}></i>
                  <h3 className="projects__modal-title">{project.title}</h3>
                  <p className="projects__modal-description">{project.date}</p>
                  <ul className="projects__modal-projects">
                    {project.highlights.map((highlight) => (
                      <li className="projects__modal-service" key={highlight}>
                        <i className="uil uil-check-circle projects__modal-icon"></i>
                        <p className="projects__modal-info">{highlight}</p>
                      </li>
                    ))}
                  </ul>
                  <p className="projects__modal-skills">{project.skills}</p>
                  {project.links.map((link) => (
                    <a className="projects__modal-link" href={link.href} target="_blank" rel="noreferrer" key={link.href}>
                      {link.label}
                      <i className="bx bx-link-external"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Project;
